import React, { useState } from 'react';
import { Menu, Search, HelpCircle, Home, Users, FileText, Copy, X, Filter, ArrowUpRight, ArrowLeft, Bot } from 'lucide-react';
import { CreditApplication } from './components/CreditApplication';
import { AdminDashboard } from './components/AdminDashboard';
export function App() {
  const [currentPage, setCurrentPage] = useState<'application' | 'admin'>('admin');
  return <div className="flex h-screen w-full bg-gray-50" data-id="element-0">
      {/* Sidebar */}
      <div className="w-16 bg-white border-r border-gray-200 flex flex-col items-center py-6 space-y-6 z-20" data-id="element-1">
        <button className="text-gray-600 hover:text-gray-900" data-id="element-2">
          <Home className="w-5 h-5" data-id="element-3" />
        </button>
        <button className="text-gray-600 hover:text-gray-900" data-id="element-4">
          <Users className="w-5 h-5" data-id="element-5" />
        </button>
        <button className="text-gray-600 hover:text-gray-900" data-id="element-6">
          <Search className="w-5 h-5" data-id="element-7" />
        </button>
        <button onClick={() => setCurrentPage('application')} className={`p-2 rounded-lg transition-colors ${currentPage === 'application' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-8">
          <FileText className="w-5 h-5" data-id="element-9" />
        </button>
        <button onClick={() => setCurrentPage('admin')} className={`p-2 rounded-lg transition-colors ${currentPage === 'admin' ? 'text-indigo-600 bg-indigo-50' : 'text-gray-600 hover:text-gray-900'}`} data-id="element-10">
          <Bot className="w-5 h-5" data-id="element-11" />
        </button>
        <div className="flex-1" data-id="element-12" />
        <button className="text-gray-600 hover:text-gray-900" data-id="element-13">
          <Users className="w-5 h-5" data-id="element-14" />
        </button>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden" data-id="element-15">
        {/* Top Navbar */}
        <header className="bg-white border-b border-gray-200 px-6 py-3 flex items-center gap-4 z-10" data-id="element-16">
          <button className="text-gray-600 hover:text-gray-900" data-id="element-17">
            <Menu className="w-6 h-6" data-id="element-18" />
          </button>

          <img src="https://cdn.magicpatterns.com/uploads/qJVgA9PEfqwGLDv8KygeAy/Property_1Creit_Pulse_Logo_black_2_(16).png" alt="Credit Pulse" className="h-8 object-contain" data-id="element-19" />

          <div className="flex-1 max-w-2xl mx-8" data-id="element-20">
            <div className="relative" data-id="element-21">
              <input type="text" placeholder="Search Companies" className="w-full px-4 py-2 pl-4 pr-10 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent" data-id="element-22" />
              <Search className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" data-id="element-23" />
            </div>
          </div>

          <div className="flex items-center gap-3" data-id="element-24">
            <button className="w-10 h-10 rounded-full border-2 border-indigo-400 flex items-center justify-center text-indigo-600 hover:bg-indigo-50" data-id="element-25">
              <HelpCircle className="w-5 h-5" data-id="element-26" />
            </button>
            <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-medium" data-id="element-27">
              IN
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 overflow-auto" data-id="element-28">
          {currentPage === 'admin' ? <AdminDashboard data-id="element-29" /> : <CreditApplication data-id="element-30" />}
        </main>
      </div>
    </div>;
}